<div class="flex flex-column gap-2">
  <div class="basis-1/2">
    <nx-table-header
      class="text-[1rem]"
      label="Ereignisse">
      <ng-template nxTemplate="end">
        <nx-default-button
          (click)="refetchEvents()"
          [style]="'light'"
          [label]="'Aktualisieren'"
          [icon]="'icon-refresh'">
        </nx-default-button>
      </ng-template>
    </nx-table-header>
    <p-table
      #httpLogTable
      [lazy]="true"
      (onLazyLoad)="loadData($event)"
      [value]="dataSource?.data"
      [scrollable]="true"
      [paginator]="true"
      [rows]="15"
      selectionMode="single" 
      [(selection)]=dataSource.selectedEvent 
      [rowsPerPageOptions]="[15, 20, 50]"
      [totalRecords]="dataSource?.totalElements"
      [loading]="loading"
      [sortField]="sortProperty" 
      [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} von {totalRecords}"
      [resizableColumns]="true">
      <ng-template pTemplate="caption">
        <div class="flex flex-row">
          <div class="basis-2/3 flex flex-row gap-2">
            <!-- no filter -->
          </div>
          <div class="basis-1/3 flex flex-row justify-end">
            <p-dropdown
              placeholder="Sortierung"
              [styleClass]="'sort'"
              appendTo="body"
              [ngModel] = "sortModel"
              [options]="sortOptions"
              optionLabel="label"
              [showClear]="false"
              (onChange)="sort($event)">
            </p-dropdown>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr >
            <th style="min-width: 5rem; width: 8rem;">Status</th>
            <th style="width: auto;">Type</th>
            <th style="min-width:9.813rem; width: 9.813rem;">Datum</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-event>
        <tr class="clickable" [pSelectableRow]="event">
          <td>
            <p-tag 
              [value]="event.state"
              [severity]="calculateSeverity(event.state)">
        </p-tag>
          </td>
          <td>{{event.eventType}}</td>
          <td>{{event.eventDatetime | date:'dd.MM. HH:mm:ss'}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="emptyMessage">Keine Ereignisse gefunden.</td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
    </ng-template>
  </div>
  <div class="basis-1/2">
    <nx-headline-box
      [label]="'Ereignis'">
    </nx-headline-box>
    <nx-default-box
    class="bg-white border-b border-gray"
    [label]="'ID'">
      {{dataSource?.selectedEvent?.id}}
      <ng-template nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedEvent?.id"
          (click)="copyToClipboard(dataSource?.selectedEvent?.id)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Type'">
      {{dataSource?.selectedEvent?.eventType}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Datum'">
      {{dataSource?.selectedEvent?.eventDatetime | date:'dd.MM.yyyy HH:mm:ss'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Zugestellt'">
      {{dataSource?.selectedEvent?.deliveryDateTime | date:'dd.MM.yyyy HH:mm:ss'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Zuletzt fehlgeschlagen'">
      {{dataSource?.selectedEvent?.lastFailedDateTime | date:'dd.MM.yyyy HH:mm:ss'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Versuch'">
      {{dataSource?.selectedEvent?.deliveryAttempt}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Letzter Statuscode'">
      {{dataSource?.selectedEvent?.lastResponseCode}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Nächster Versuch nach'">
      {{dataSource?.selectedEvent?.nextSendAttemptNotBefore | date:'dd.MM.yyyy HH:mm:ss'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Entity ID'">
      {{dataSource?.selectedEvent?.entityId }}
    <ng-template nxTemplate="end">
      <nx-default-button
        [disabled]="!this.dataSource?.selectedEvent?.entityId"
        (click)="copyToClipboard(dataSource?.selectedEvent?.entityId)"
        [style]="'light'"
        [icon]="'icon-copy'"
        [tooltip]="'Kopieren'">
      </nx-default-button>
    </ng-template>
  </nx-default-box>
  <nx-default-box
  class="bg-white border-b border-gray"
  [label]="'Entity External ID'">
    {{dataSource?.selectedEvent?.entityExternalId}} 
  <ng-template nxTemplate="end">
    <nx-default-button
      [disabled]="!this.dataSource?.selectedEvent?.entityExternalId"
      (click)="copyToClipboard(dataSource?.selectedEvent?.entityExternalId)"
      [style]="'light'"
      [icon]="'icon-copy'"
      [tooltip]="'Kopieren'">
    </nx-default-button>
  </ng-template>
</nx-default-box>
    
    <!-- <nx-headline-box
      class="mt-2"
      [label]="'Request Body'">
      <ng-template nxTemplate="end">
        <nx-default-button
          [disabled]="!this.dataSource?.selectedHttpLogEntry?.requestBody"
          [style]="'light'"
          [icon]="'icon-copy'"
          (click)="copyRequestContent(this.dataSource?.selectedHttpLogEntry?.requestBody)"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-headline-box>
    <div class="py-2 bg-white">
      <nx-empty-box
        *ngIf="!this.dataSource?.selectedHttpLogEntry?.requestBody"
        [label]="'RequestBody is leer.'">
      </nx-empty-box>
      <ng-container *ngIf="this.dataSource?.selectedHttpLogEntry?.requestBody && isJsonString(this.dataSource?.selectedHttpLogEntry?.requestBody)">
        <ace [config]="editorConfig" [mode]="'json'" id="editor1" [disabled]="true" [theme]="'github'" [value]="getCodeModel(this.dataSource?.selectedHttpLogEntry?.requestBody)"></ace>
      </ng-container>
      <ng-container *ngIf="this.dataSource?.selectedHttpLogEntry?.requestBody && !isJsonString(this.dataSource?.selectedHttpLogEntry?.requestBody)">
        <ace [config]="editorConfig" [mode]="'text'" id="editor1" [disabled]="true" [theme]="'github'" [value]="getString(this.dataSource?.selectedHttpLogEntry?.requestBody)"></ace>
      </ng-container>
    </div>

    <nx-headline-box
      class="mt-2"
      [label]="'Response Body'">
      <ng-template nxTemplate="end">
        <nx-default-button
        [disabled]="!this.dataSource?.selectedHttpLogEntry?.responseBody"
          (click)="copyRequestContent(this.dataSource?.selectedHttpLogEntry?.responseBody)"
          [style]="'light'"
          [icon]="'icon-copy'"
          [tooltip]="'Kopieren'">
        </nx-default-button>
      </ng-template>
    </nx-headline-box>
    <div class="py-2 bg-white">
      <nx-empty-box
        *ngIf="!this.dataSource?.selectedHttpLogEntry?.responseBody"
        [label]="'ResponseBody is leer.'">
      </nx-empty-box>
      <ng-container *ngIf="this.dataSource?.selectedHttpLogEntry?.responseBody">
        <ace [config]="editorConfig" [mode]="'json'" id="editor2"  [disabled]="true"   [theme]="'github'" [value]="getCodeModel(this.dataSource?.selectedHttpLogEntry?.responseBody)" [ngStyle]="{'height':'calc(100% - 300px)'}"></ace>
      </ng-container>
    </div>-->

  </div> 
</div>